<template>
  <div
    class="of-box of-tabs"
    style="border-radius: 0px;"
  >
    <div
      class="of-container is-vertical"
      style="border-radius: 0px;"
    >
      <!-- <div class="of-aside of-tabs-bar tabs-byleft" style="padding:0px">
                <div class="clear-both" style="padding:0px">
                    <ul class="newTab">
                        <li :class="tabIndex == index ? 'tabActive' : ''" v-for="(item, index) in tabsList" :key="index"
                            @click="changeTab(item, index)">{{ item.label }}</li>
                        <li class="newTabIcon"></li>
                    </ul>
                </div>
            </div> -->
      <div class="of-main">
        <div class="of-box">
          <div class="of-container is-vertical base-page-box">
            <div class="of-aside base-search-box ">
              <div class="of-filter clearfix">
                <div class="filter-left">
                  <el-button
                    v-if="MoreBtn && false"
                    type="primary"
                    size="small"
                    icon="fa fa-plus"
                    @click="showEdit()"
                  >新增
                  </el-button>
                  <el-button
                    v-if="false"
                    v-access:flow
                    type="primary"
                    size="small"
                    icon="fa fa-plus"
                    @click="showStorageEdit()"
                  >
                    设备入库申请</el-button>
                  <el-button
                    v-access:export
                    type="primary"
                    size="small"
                    :loading="exportLoading"
                    icon="fa fa-cloud-download"
                    @click="ExportAction()"
                  >导出</el-button>
                </div>
                <div class="filter-right">
                  <!-- <el-input v-model="pageQuery.fastSearchKeyWord"
                        placeholder="请输入关键字搜索"
                        size="small"
                        clearable
                        prefix-icon="fa fa-search"
                        @change="search"></el-input> -->

                  <el-popover
                    ref="popoverDom"
                    placement="bottom-start"
                    width="320"
                    style="max-height: 380px;overflow: auto;"
                    popper-class="el_popover_class"
                    trigger="click"
                  >
                    <div>
                      <div>
                        <el-form
                          label-width="80px"
                          :model="pageQuery"
                          class="search-form"
                        >
                          <el-form-item
                            label="项目"
                            class="search-form-item"
                          >
                            <el-select
                              v-model="pageQuery.ProjectId"
                              filterable
                              placeholder="请选择"
                              size="small"
                              @change="pageQuery.ResidenceId = '';pageQuery.RegionId = ''"
                            >
                              <el-option
                                label="请选择"
                                value=""
                              ></el-option>
                              <el-option
                                v-for="item in ProjectOpts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <!-- <el-form-item
                            label="区域"
                            class="search-form-item"
                          >
                            <el-select
                              v-model="pageQuery.RegionId"
                              placeholder="请选择"
                              size="small"
                            >
                              <el-option
                                label="请选择"
                                value=""
                              ></el-option>
                              <el-option
                                v-for="item in RegionOpts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item> -->
                          <el-form-item
                            label="驻地"
                            class="search-form-item"
                          >
                            <el-select
                              v-model="pageQuery.ResidenceIds"
                              multiple
                              filterable
                              placeholder="请选择"
                              size="small"
                            >
                              <el-option
                                label="请选择"
                                value=""
                              ></el-option>
                              <el-option
                                v-for="item in ResidenceOpts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            label="运营组/服务对象"
                            class="search-form-item"
                          >
                            <el-select
                              v-model="pageQuery.ServiceId"
                              filterable
                              placeholder="请选择"
                              size="small"
                            >
                              <el-option
                                label="请选择"
                                value=""
                              ></el-option>
                              <el-option
                                v-for="item in ServiceOpts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            label="设备类型"
                            size="small"
                            class="search-form-item"
                          >
                            <el-select
                              v-model="pageQuery.ModelPowerType"
                              filterable
                              clearable
                              placeholder="请选择设备类型"
                            >
                              <el-option
                                v-for="item in powerType"
                                :key="item.Value"
                                :label="item.Value"
                                :value="item.Value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            label="自编类型"
                            size="small"
                            class="search-form-item"
                          >
                            <el-select
                              v-model="pageQuery.ModelType"
                              clearable
                              placeholder="请选择自编类型"
                            >
                              <el-option
                                v-for="item in modelTypeOptions"
                                :key="item.Value"
                                :label="item.Value"
                                :value="item.Value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <!-- <el-form-item label="车牌号码"
                                        class="form-item-col-6 margin-bottom-5">
                            <el-input v-model="pageQuery.PlateNo"
                                      size="small"
                                      placeholder="请输入车牌号码"></el-input>
                          </el-form-item>
                          <el-form-item label="自编号"
                                        class="form-item-col-6 margin-bottom-5">
                            <el-input v-model="pageQuery.SelfNumber"
                                      size="small"
                                      placeholder="请输入自编号"></el-input>
                          </el-form-item> -->
                          <!-- <el-form-item label="所有人"
                                        class="form-item-col-6 margin-bottom-5">
                            <el-input v-model="pageQuery.CompanyName"
                                      size="small"
                                      placeholder="请输入所有人"></el-input>
                          </el-form-item> -->
                          <el-form-item
                            label="状态"
                            class="search-form-item"
                          >
                            <el-select
                              v-model="pageQuery.Status"
                              filterable
                              placeholder="请选择"
                              size="small"
                            >
                              <el-option
                                label="请选择"
                                value=""
                              ></el-option>
                              <el-option
                                label="草稿"
                                value="0"
                              ></el-option>
                              <el-option
                                label="在用"
                                value="1"
                              ></el-option>
                              <el-option
                                label="入库审批中"
                                value="2"
                              ></el-option>
                              <el-option
                                label="变卖审批中"
                                value="3"
                              ></el-option>
                              <el-option
                                label="报废审批中"
                                value="4"
                              ></el-option>
                              <el-option
                                label="调动审批中"
                                value="5"
                              ></el-option>
                              <el-option
                                label="变更审批中"
                                value="6"
                              ></el-option>
                              <el-option
                                label="已变卖"
                                value="98"
                              ></el-option>
                              <el-option
                                label="已报废"
                                value="99"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            label="品牌"
                            size="small"
                            class="search-form-item"
                          >
                            <el-input
                              v-model="pageQuery.Brand"
                              placeholder="请输入品牌"
                              size="small"
                              clearable
                              prefix-icon="fa fa-search"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            label="关键字"
                            size="small"
                            class="search-form-item"
                          >
                            <el-input
                              v-model="pageQuery.fastSearchKeyWord"
                              placeholder="设备号码 / 设备识别代号 / 自编号"
                              size="small"
                              clearable
                              prefix-icon="fa fa-search"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            label="注册时间"
                            size="small"
                            class="search-form-item"
                          >
                            <el-date-picker
                              v-model="DispatchDate"
                              placeholder="请选择"
                              style="width: auto;"
                              type="datetimerange"
                              format="yyyy-MM-dd [           ] HH:mm:ss"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              :default-time="['00:00:00', '23:59:59']"
                              @change="dateChange"
                            >
                            </el-date-picker>
                          </el-form-item>
                          <div
                            class="btns"
                            style="text-align: left;padding-top: 5px;"
                          >
                            <el-button
                              type="primary"
                              size="small"
                              @click="search"
                            >查
                              询</el-button>
                            <el-button
                              type="primary"
                              size="small"
                              @click="resetsSearch"
                            >重
                              置</el-button>
                          </div>
                        </el-form>
                      </div>

                    </div>
                    <el-button
                      slot="reference"
                      size="small"
                      style="margin-left:10px;"
                      icon="el-icon-search"
                      @click="advSearch = (advSearch ? 0 : 1); initPageBoxHeight()"
                    >
                      高级搜索</el-button>
                  </el-popover>
                  <!-- <el-button
                type="primary"
                size="small"
                @click="advSearch=(advSearch?0:1);initPageBoxHeight()"
              >高级搜索</el-button> -->
                </div>
              </div>

            </div>
            <div
              ref="tableBox"
              class="of-main"
            >
              <div class="of-table">
                <el-table
                  v-loading="isloading"
                  border
                  resizable
                  :data="listData"
                  style="width: 100%"
                  size="small"
                  :height="boxHeight"
                  :row-class-name="setRowClass"
                  :header-cell-style="{ background: '#f2f3f5' }"
                  @selection-change="tabChange"
                >
                  <!-- <el-table-column type="selection" width="50" fixed></el-table-column> -->
                  <el-table-column
                    v-for="(item, index) in tableCols"
                    :key="index"
                    size="mini"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    :sortable="item.sortable"
                  >
                    <template v-slot="scope">
                      <el-tooltip
                        v-if="item.shwotip"
                        :content="`${format1(scope, scope.column, scope.row[item.prop])}`"
                        placement="bottom"
                        effect="light"
                      >
                        <span>{{ format1(scope, scope.column, scope.row[item.prop]) }}</span>
                      </el-tooltip>
                      <span v-else>{{ format1(scope, scope.column, scope.row[item.prop]) }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    fixed="right"
                    label="操作"
                    width="180"
                  >
                    <template v-slot="scope">
                      <!-- <el-button
                    v-access:modify
                    :disabled="scope.row.Status>=2 && scope.row.Status<=5"
                    class="table-ctrlbtn"
                    style="margin-right: 8px;"
                    size="small"
                    icon="fa fa-edit"
                    @click="showEdit(scope.row)"
                  >编辑</el-button> -->
                      <el-button
                        v-access:read
                        class="table-ctrlbtn"
                        style="margin-right: 8px;"
                        size="small"
                        icon="el-icon-info"
                        @click="showAll(scope.row)"
                      >详情</el-button>
                      <el-dropdown
                        v-if="false"
                        class="table-ctrlbtn"
                        @command="menuClick"
                      >
                        <el-button
                          size="small"
                          icon="fa fa-ellipsis-v"
                        ></el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            :disabled="scope.row.Status >= 2 && scope.row.Status <= 5"
                            :command="{ 'type': 'edit', 'data': scope.row }"
                          >设备信息编辑</el-dropdown-item>
                          <!-- <el-dropdown-item :command="{'type': 'model', 'data': scope.row}">设备类型信息</el-dropdown-item> -->
                          <el-dropdown-item
                            v-if="scope.row.VehicleType == '牵引车'"
                            :command="{ 'type': 'bangV', 'data': scope.row }"
                          >绑定挂车
                          </el-dropdown-item>

                          <el-dropdown-item
                            v-if="scope.row.VehicleType != '挂车'"
                            :command="{ 'type': 'resetM', 'data': scope.row }"
                          >重置码表
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ 'type': 'tyre', 'data': scope.row }">
                            <span class="my-dropdown-item"> 轮胎信息编辑
                              <i
                                v-if="scope.row.TyreCount == 0 && scope.row.Status !== 98 && scope.Status !== 99"
                                class="remind-dog"
                              ></i></span>
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ 'type': 'finance', 'data': scope.row }">财务信息编辑</el-dropdown-item>
                          <el-dropdown-item :command="{ 'type': 'insurance', 'data': scope.row }">
                            <span class="my-dropdown-item">
                              保险信息编辑
                              <i
                                v-if="scope.row.InsuranceCount == 0 && scope.row.Status !== 98 && scope.Status !== 99"
                                class="remind-dog"
                              ></i>
                            </span>
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ 'type': 'credential', 'data': scope.row }">
                            <span class="my-dropdown-item">证件信息编辑
                              <i
                                v-if="scope.row.CardCount == 0 && scope.row.Status !== 98 && scope.Status !== 99"
                                class="remind-dog"
                              >
                              </i>
                            </span>
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ 'type': 'hardware', 'data': scope.row }">硬件信息编辑</el-dropdown-item>
                          <el-dropdown-item :command="{ 'type': 'maintenance', 'data': scope.row }">保养信息编辑
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ 'type': 'change', 'data': scope.row }">设备变动</el-dropdown-item>
                          <el-dropdown-item :command="{ 'type': 'cylinderPlan', 'data': scope.row }">分仓配置
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="of-aside">
              <my-pagination
                :total="total"
                :pageSize="pageQuery.pageSize"
                :pageIndex="pageQuery.pageIndex"
                @change="pageChange"
              ></my-pagination>
            </div>
          </div>
          <my-drawer
            :visible="editStorageVisible"
            :title="'设备入库'"
            size="600px"
            :isSubmit="isSubmit"
            @onCancel="canceStoragelEdit"
          >
            <storage-edit-page
              slot="content"
              ref="VehicleStorageEditPage"
              :vehicleInfo="editItem"
              :isOutSideVehicle="'0'"
            >
            </storage-edit-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="editStorageVisible = false"
              >关 闭</el-button>
              <el-button
                size="small"
                type="primary"
                @click="sumitVehicleStorage(0)"
              >发起入库</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="editVisible"
            :title="'设备信息'"
            size="600px"
            :isSubmit="isSubmit"
            @onCancel="cancelEdit"
            @onSubmit="sumitDetail"
          >
            <edit-page
              slot="content"
              ref="VehicleEditPage"
              :vehicleInfo="editItem"
            >
            </edit-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="cancelEdit"
              >关 闭</el-button>
              <el-button
                size="small"
                type="primary"
                @click="sumitDetail"
              >提 交</el-button>
              <el-button
                v-if="editItem != null && editItem.Status == 0"
                type="primary"
                size="small"
                @click="sumitVehicleStorage(1)"
              >发起入库</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="modelVisible"
            :title="'设备类型信息'"
            size="600px"
            :isSubmit="isSubmit"
            @onCancel="() => { modelVisible = false }"
          >
            <model-page
              slot="content"
              ref="VehicleModelPage"
              :vehicleInfo="editItem"
              @exit="() => { modelVisible = false }"
            >
            </model-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="modelVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="tyreVisible"
            :title="'轮胎信息'"
            :size="drawerWidth"
            :isSubmit="isSubmit"
            @onCancel="() => { tyreVisible = false }"
          >
            <tyre-page
              slot="content"
              ref="VehicleTyrePage"
              :vehicleInfo="editItem"
              @exit="() => { tyreVisible = false }"
            >
            </tyre-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="tyreVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="financeVisible"
            :title="'财务信息'"
            size="600px"
            :isSubmit="isFinanceSubmit"
            @onCancel="() => { financeVisible = false }"
            @onSubmit="financeSave"
          >
            <finance-page
              slot="content"
              ref="VehicleFinancePage"
              :vehicleInfo="editItem"
              @exit="() => { financeVisible = false }"
            >
            </finance-page>
          </my-drawer>
          <my-drawer
            :visible="insuranceVisible"
            :title="'保险信息'"
            :size="drawerWidth"
            :isSubmit="isFinanceSubmit"
            @onCancel="() => { insuranceVisible = false }"
          >
            <insurance-page
              slot="content"
              ref="VehicleInsurancePage"
              :vehicleInfo="editItem"
              @exit="() => { insuranceVisible = false }"
            >
            </insurance-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="insuranceVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="credentialsVisible"
            :title="'证件信息'"
            :size="drawerWidth"
            :isSubmit="isCredentialsSubmit"
            @onCancel="() => { credentialsVisible = false }"
          >
            <credentials-page
              slot="content"
              ref="VehicleCredentialsPage"
              :vehicleInfo="editItem"
              @exit="() => { credentialsVisible = false }"
            >
            </credentials-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="credentialsVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="cylinderPlanVisible"
            :title="editItem == null ? '' : editItem.PlateNo + '-分仓配置'"
            :size="drawerWidth"
            :isSubmit="isCylinderPlanSubmit"
            @onCancel="() => { cylinderPlanVisible = false }"
          >
            <cylinder-plan-page
              slot="content"
              ref="VehicleCylinderPlanPage"
              :vehicleInfo="editItem"
              @exit="() => { cylinderPlanVisible = false }"
            >
            </cylinder-plan-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="cylinderPlanVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="passVisible"
            :title="'通行证信息'"
            :size="drawerWidth"
            :isSubmit="isPassSubmit"
            @onCancel="() => { passVisible = false }"
          >
            <pass-page
              slot="content"
              ref="VehiclePassPage"
              :vehicleInfo="editItem"
              @exit="() => { passVisible = false }"
            >
            </pass-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="passVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="hardwareVisible"
            :title="'硬件信息'"
            :size="drawerWidth"
            :isSubmit="isPassSubmit"
            @onCancel="() => { hardwareVisible = false }"
          >
            <hardware-page
              slot="content"
              ref="VehicleHardwarePage"
              :vehicleInfo="editItem"
              @exit="() => { hardwareVisible = false }"
            >
            </hardware-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="hardwareVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="allVisible"
            :title="'所有信息'"
            size="80%"
            @onCancel="allVisible = false"
          >
            <all-info
              slot="content"
              ref="AllInfoPage"
              :vehicleInfo="editItem"
            ></all-info>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="allVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>
          <my-drawer
            :visible="maintenanceVisible"
            title="保养信息"
            :size="drawerWidth"
            @onCancel="() => { maintenanceVisible = false }"
          >
            <maintenance-page
              slot="content"
              ref="VehicleMaintenancePage"
              :vehicleInfo="editItem"
              @exit="() => { maintenanceVisible = false }"
            >
            </maintenance-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="maintenanceVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>

          <my-drawer
            :visible="changeVisible"
            title="设备变动"
            :size="drawerWidth"
            @onCancel="() => { changeVisible = false }"
          >
            <vehicle-change-page
              slot="content"
              ref="VehicleChangePage"
              :vehicleInfo="editItem"
              @exit="() => { changeVisible = false }"
            >
            </vehicle-change-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="changeVisible = false"
              >关 闭</el-button>
              <el-button
                size="small"
                type="primary"
                :loading="isChangeSubmit"
                @click="sumitVehicleChange"
              >{{ isChangeSubmit ? '提交中 ...' : '发起设备变动' }}
              </el-button>
            </span>
          </my-drawer>

          <!-- <my-drawer
        :visible="changeLogVisible"
        :title="'车辆变动日志信息'"
        :size="drawerWidth"
        @onCancel="changeLogVisible=false"
      >
        <change-log-page slot="content" ref="AllChangeInfoPage" :vehicleInfo="editItem"></change-log-page>
        <span slot="footer" class="dialog-footer">
          <el-button @click="changeLogVisible = false">关 闭</el-button>
        </span>
      </my-drawer> -->

          <my-drawer
            :visible="changeLogVisible"
            :title="'设备变动日志信息'"
            :size="drawerWidth"
            @onCancel="changeLogVisible = false"
          >
            <change-log-view-page
              slot="content"
              ref="AllChangeInfoPage"
              :vehicleInfo="editItem"
            ></change-log-view-page>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button
                size="small"
                @click="changeLogVisible = false"
              >关 闭</el-button>
            </span>
          </my-drawer>

          <dialogue
            :visible="bangvShow"
            :title="`绑定挂车`"
            :isSubmit="isSubmit"
            submitName="保 存"
            @onCancel="() => { bangvShow = false }"
            @onSubmit="submitBang"
          >
            <bangVehiclePage
              v-if="bangvShow"
              slot="content"
              ref="bangvpage"
              :vehicleId="editItem.Id"
              @falseSubmit="isSubmit = false"
              @close="submitBangFinish"
            ></bangVehiclePage>
            <!-- </my-drawer> -->
          </dialogue>

          <dialogue
            :visible="resetVMShow"
            :title="`重置码表`"
            :isSubmit="isSubmit"
            submitName="保 存"
            width="45%"
            @onCancel="() => { resetVMShow = false }"
            @onSubmit="submitResetVM"
          >
            <bresetMileagePage
              v-if="resetVMShow"
              slot="content"
              ref="resetVMpage"
              :vehicleId="editItem.Id"
              @falseSubmit="isSubmit = false"
              @close="submitBangFinish"
            ></bresetMileagePage>
            <!-- </my-drawer> -->
          </dialogue>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import {
  getVehicleList,
  exportFileId
} from '@/modules/vehicle/api/vehicle.js'

import MyPagination from "@/components/pagination"
import MyDrawer from '@/components/drawer'
import moment, { isDate } from 'moment'
import { getEditOptions, } from "@/modules/vehicle/api/vehicleModel.js";
import { getBaseSearchOptsHasIsolation } from '@/modules/report/api/baseSearch'
import editPage from '@/modules/vehicle/pages/vehicle/edit'
import storageEditPage from '@/modules/vehicle/pages/vehicle/storageEdit'
import modelPage from '@/modules/vehicle/pages/vehicle/editPages/model'
import tyrePage from '@/modules/vehicle/pages/vehicle/editPages/tyre'
import financePage from '@/modules/vehicle/pages/vehicle/editPages/finance'
import insurancePage from '@/modules/vehicle/pages/vehicle/editPages/insurance'
import credentialsPage from '@/modules/vehicle/pages/vehicle/editPages/credentials'
import cylinderPlanPage from '@/modules/vehicle/pages/vehicle/editPages/cylinderPlan'
import passPage from '@/modules/vehicle/pages/vehicle/editPages/pass'
import hardwarePage from '@/modules/vehicle/pages/vehicle/editPages/hardware'
import allInfo from '@/modules/vehicle/pages/vehicle/allInfo'
import maintenancePage from '@/modules/vehicle/pages/vehicle/editPages/maintenanceList'
import vehicleChangePage from '@/modules/vehicle/pages/vehicle/editPages/vehicleChangeEdit'
import changeLogViewPage from '@/modules/vehicle/pages/vehicle/editPages/changeLogList'
import bangVehiclePage from '@/modules/vehicle/pages/vehicle/bangVehicle'
import bresetMileagePage from '@/modules/vehicle/pages/vehicle/resetMileage'
import dialogue from '@/components/dialogue'

export default {
  name: 'VehicleList',
  components: {
    MyPagination,
    MyDrawer,
    editPage,
    storageEditPage,
    modelPage,
    tyrePage,
    financePage,
    insurancePage,
    credentialsPage,
    cylinderPlanPage,
    passPage,
    hardwarePage,
    allInfo,
    maintenancePage,
    vehicleChangePage,
    // ChangeLogPage,
    changeLogViewPage,
    bangVehiclePage,
    bresetMileagePage,
    dialogue
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return { projectId: '' }
      }
    }
  },
  data () {
    return {
      tabIndex: 0,
      tabsActive: 'vehicleList',
      tabsList: [
        {
          name: 'vehicleList',
          label: '自有设备'
        },
        {
          name: 'externalVehicleList',
          label: '外协设备'
        }
      ],
      advSearch: 0,
      baseInfo: null,
      pageQuery: {
        pageSize: 50,
        pageIndex: 1,
        Brand: '',
        IsOutSideVehicle: 0,
        sortOrder: "desc",
        sortField: "PutInStorageDate",
        fastSearchFields: "PlateNo,CarframeNo,SelfNumber",
        fastSearchKeyWord: "",
        /// 状态(0-草稿,1-在用,2-入库审批中,3-变卖审批中,4-报废审批中,5-调动审批中,6-变更审批中,98-已变卖,99-已报废)
        Status: null,
        ProjectId: '',
        ResidenceId: '',
        ResidenceIds: [],
        SelfNumber: '',
        PlateNo: '',
        CompanyName: '',
        RegionId: '',
        ServiceId: '',
        StartTime: null,
        EndTime: null,
        ModelType: '',
        ModelPowerType: '',
      },
      tableCols: [
        { label: "入库时间", prop: "PutInStorageDate", width: "150", type: "", sortable: true, shwotip: true },
        { label: "注册日期", prop: "RegisterDate", width: "150", type: "", sortable: true, shwotip: true },
        { label: "设备号码", prop: "PlateNo", width: "100", type: "", sortable: true, shwotip: true },
        { label: "自编号", prop: "SelfNumber", width: "120", type: "", sortable: true, shwotip: true },
        { label: "发证日期", prop: "LicenceDate", width: "100", type: "", sortable: true },
        { label: "设备类型", prop: "VehicleModelType", width: "140", type: "", sortable: true, shwotip: true },
        { label: "自编类型", prop: "VehicleType", width: "100", type: "", sortable: true },
        { label: "设备类型代号", prop: "BrandNo", width: "180", type: "", sortable: true, shwotip: true },
        { label: "设备识别代号", prop: "CarframeNo", width: "180", type: "", sortable: true, shwotip: true },
        { label: "所有人", prop: "CompanyName", width: "180", type: "", sortable: true, shwotip: true },
        { label: "状态", prop: "Status", width: "120", type: "" },
        { label: "项目", prop: "ProjectName", width: "170", type: "", shwotip: true },
        // { label: "区域", prop: "RegionName", width: "150", type: "", shwotip: true },
        { label: "驻地", prop: "ResidenceName", width: "150", type: "", shwotip: true },
      ],
      total: 0,
      boxHeight: 0,
      listData: [],
      isloading: false,
      tableSelect: [],
      editItem: null,
      modelTypeOptions: [],
      powerType: [],
      editVisible: false,
      editStorageVisible: false,
      drawerWidth: '800px',
      isSubmit: false,
      DispatchDate: [],
      exportLoading: false,
      modelVisible: false,
      tyreVisible: false,
      financeVisible: false,
      isFinanceSubmit: false,
      insuranceVisible: false,
      credentialsVisible: false,
      cylinderPlanVisible: false,
      isCredentialsSubmit: false,
      isCylinderPlanSubmit: false,
      passVisible: false,
      isPassSubmit: false,
      hardwareVisible: false,
      allVisible: false,
      maintenanceVisible: false,
      changeVisible: false,
      isChangeSubmit: false,
      changeLogVisible: false,
      bangvShow: false,
      resetVMShow: false,
    }
  },
  computed: {
    PlateTypeOpts () {
      if (this.baseInfo)
        return this.baseInfo.PlateTypes.map(p => { return { id: p.Value, name: p.Value } })
      return []
    },
    ProjectOpts () {
      if (this.baseInfo) {
        if (this.pageQuery.PlateName)
          return this.baseInfo.AllProList.filter(p => { return !p.ParentId && p.Plate == this.pageQuery.PlateName }).map(p => { return { id: p.Id, name: p.Name } })
        return this.baseInfo.AllProList.filter(p => { return !p.ParentId }).map(p => { return { id: p.Id, name: p.Name } })
      }
      return []
    },
    RegionOpts () {
      if (this.baseInfo) {
        if (this.pageQuery.ProjectId)
          return this.baseInfo.AllProList.filter(p => { return p.ParentId && p.ParentId == this.pageQuery.ProjectId }).map(p => { return { id: p.Id, name: p.Name } })
      }
      return []
    },
    ResidenceOpts () {
      if (this.baseInfo) {
        if (this.pageQuery.ProjectId)
          return this.baseInfo.ResidenceList.filter(p => { return p.ProjectId == this.pageQuery.ProjectId }).map(p => { return { id: p.Id, name: p.Name } })
      }
      return []
    },
    ServiceOpts () {
      if (this.baseInfo) {
        return this.baseInfo.ServiceList.map(p => { return { id: p.Id, name: p.Name } })
      }
      return []
    },
    MoreBtn () {
      return this.$route.query.more ? true : false
    }
  },
  mounted () {
    this.initPageBoxHeight()
    this.initOpt()
    if (this.params.projectId) {
      this.pageQuery.ProjectId = this.params.projectId
    }
    this.loadPageData()
    getEditOptions().then((res) => {
      if (res && res.data.Code == 0) {
        let baseInfo = res.data.Data;
        this.powerType = baseInfo.PowerType
        this.modelTypeOptions = baseInfo.VehicleType;
      }
    });
  },
  methods: {
    changeTab (item, index) {
      this.tabsActive = item.name

      this.tabIndex = index
      if (item.name == "vehicleList") {
        this.pageQuery.IsOutSideVehicle = 0
      }
      else {
        this.pageQuery.IsOutSideVehicle = 1
      }
      this.loadPageData()
    },
    initPageBoxHeight () {
      this.MixinBoxHeight(50, 'base-page-box', () => {
        let searchHeight = 80
        this.boxHeight = this.boxHeight - searchHeight
      })
    },
    initOpt () {
      getBaseSearchOptsHasIsolation().then(rep => {
        if (rep.data.Code == 0) {
          this.baseInfo = rep.data.Data
        }
      })
    },
    loadPageData () {
      this.isloading = true
      if (this.DispatchDate && this.DispatchDate.length > 0) {
        this.pageQuery.StartTime = this.datetime(this.DispatchDate[0])
        this.pageQuery.EndTime = this.datetime(this.DispatchDate[1])
      }
      if (this.pageQuery.ResidenceIds.length > 0) {
        this.pageQuery.ResidenceId = this.pageQuery.ResidenceIds.toString()
      }
      else if (this.pageQuery.ResidenceIds.length == 0) {
        this.pageQuery.ResidenceId = ''
      }
      getVehicleList(this.pageQuery).then((rep) => {
        let repData = rep.data
        if (repData.Code == 0) {
          this.total = repData.Data.total
          this.listData = repData.Data.rows
        }
        this.isloading = false
      })
    },
    dateChange (val) {
      if (val == null) {
        this.pageQuery.StartTime = null
        this.pageQuery.EndTime = null
      }
    },
    resetsSearch () {
      this.pageQuery.ProjectId = ''
      this.pageQuery.ResidenceId = ''
      this.pageQuery.ResidenceIds = []
      this.pageQuery.RegionId = ''
      this.pageQuery.Status = null
      this.pageQuery.SelfNumber = ''
      this.pageQuery.PlateNo = ''
      this.pageQuery.CompanyName = ''
      this.pageQuery.ServiceId = ''
      this.pageQuery.Brand = ''
      this.pageQuery.StartTime = null
      this.pageQuery.EndTime = null
      this.pageQuery.ModelType = ''
      this.pageQuery.ModelPowerType = ''
      this.DispatchDate = []
      this.pageQuery.pageIndex = 1
      this.pageQuery.fastSearchKeyWord = ''
      if (this.params.projectId) {
        this.pageQuery.ProjectId = this.params.projectId
      }
      this.loadPageData()
    },
    tabChange (val) {
      this.selectRows = val
    },
    pageChange (_index, _size) {
      this.pageQuery.pageIndex = _index
      this.pageQuery.pageSize = _size
      this.loadPageData()
    },
    sumitDetail () {
      this.isSubmit = true
      this.$refs.VehicleEditPage.save((valid, data) => {
        if (valid) {
          this.editVisible = false
          this.$refs.VehicleEditPage.resetFields() // 重置表单方法
          this.editItem = null
          this.loadPageData()
        } else {
          //console.log(data)
        }
        this.isSubmit = false

      })
    },
    //发起车辆入库
    sumitVehicleStorage (val) {
      this.isSubmit = true
      if (val == 0) {
        this.$refs.VehicleStorageEditPage.commit((valid, data) => {
          if (valid) {
            this.editStorageVisible = false
            this.$refs.VehicleStorageEditPage.resetFields() // 重置表单方法
            this.editItem = null
            this.isSubmit = false
            this.loadPageData()
          } else {
            this.isSubmit = false
            //console.log(data)
          }
        })
      } else if (val == 1) {
        this.$refs.VehicleEditPage.commit((valid, data) => {
          this.isSubmit = false
          if (valid) {
            this.editVisible = false
            this.$refs.VehicleEditPage.resetFields() // 重置表单方法
            this.editItem = null
            this.loadPageData()
          } else {
            //console.log(data)
          }
        })
      }

    },

    //发起车辆变动
    sumitVehicleChange () {
      this.isChangeSubmit = true
      this.$refs.VehicleChangePage.changeCommit((valid, data) => {
        if (valid) {
          this.changeVisible = false
          this.$refs.VehicleChangePage.resetFields() // 重置表单方法
          this.editItem = null
          this.loadPageData()
          this.isChangeSubmit = false

        } else {
          //console.log(data)
          this.isChangeSubmit = false
        }

      })
    },

    refreshWidth () {
      let needWidth = window.innerWidth - 250
      this.drawerWidth = '60%'
    },
    showEdit (_value) {
      if (_value) {
        this.editItem = _value
      } else {
        this.editItem = null
      }
      this.refreshWidth()
      this.editVisible = true
    },
    showStorageEdit (_value) {
      if (_value) {
        this.editItem = _value
      } else {
        this.editItem = null
      }
      this.refreshWidth()
      this.editStorageVisible = true
    },
    cancelEdit () {
      this.editVisible = false
      this.editItem = null
    },
    canceStoragelEdit () {
      this.editStorageVisible = false
      this.editItem = null
    },
    submitBang () {
      this.$refs.bangvpage.commit()
    },
    submitResetVM () {
      this.$refs.resetVMpage.commit()
    },
    submitBangFinish () {
      this.editItem = null
      this.bangvShow = false
      this.resetVMShow = false
    },
    menuClick (command) {
      this.refreshWidth()
      this.editItem = command.data
      switch (command.type) {
        case 'edit':
          this.showEdit(command.data)
          break
        case 'model':
          this.modelVisible = true
          break
        case 'tyre':
          this.tyreVisible = true
          break
        case 'finance':
          this.financeVisible = true
          break
        case 'insurance':
          this.insuranceVisible = true
          break
        case 'credential':
          this.credentialsVisible = true
          break
        case 'cylinderPlan':
          this.cylinderPlanVisible = true
          break
        case 'pass':
          this.passVisible = true
          break
        case 'hardware':
          this.hardwareVisible = true
          break
        case 'maintenance':
          this.maintenanceVisible = true
          break
        case 'change':
          if (this.editItem.Status >= 2 && this.editItem.Status <= 5) {
            this.toast({ content: '当前设备正在审核中，不可再次发起设备变动审核', type: 'warning', time: 2000 })
          } else if (this.editItem.Status == 98) {
            this.toast({ content: '当前设备已变卖，不可发起设备变动审核', type: 'warning', time: 2000 })
          } else if (this.editItem.Status == 99) {
            this.toast({ content: '当前设备已报废，不可发起设备变动审核', type: 'warning', time: 2000 })
          } else {
            this.changeVisible = true
          }
          break
        case 'changeLog':
          this.changeLogVisible = true
          break
        case 'bangV':
          this.bangvShow = true
          break
        case 'resetM':
          this.resetVMShow = true
          break
        // case 'changeToUse':
        //   this.changeLogVisible = true
        //   break
      }
    },
    financeSave () {
      this.isFinanceSubmit = true
      this.$refs.VehicleFinancePage.save((valid, data) => {
        this.isFinanceSubmit = false
        if (valid) {
          this.financeVisible = false
          this.$refs.VehicleFinancePage.resetFields() // 重置表单方法
          this.editItem = null
          this.loadPageData()
        } else {
          //console.log(data)
        }
      })
    },
    search (keyword) {
      this.advSearch = (this.advSearch ? 0 : 1)
      this.pageQuery.pageIndex = 1
      this.loadPageData()
      this.$refs.popoverDom.doClose()
    },
    showAll (row) {
      this.refreshWidth()
      this.editItem = row
      this.allVisible = true
    },
    format1 (row, column, cellValue, index) {
      if (column.property == "LicenceDate") {
        if (cellValue)
          return moment(cellValue).format('YYYY-MM-DD')
      }
      if (column.property == "Status") {
        let rs = ''
        switch (cellValue) {
          case 0:
            rs = '草稿'
            break
          case 1:
            rs = '在用'
            break
          case 2:
            rs = '入库审批中'
            break
          case 3:
            rs = '变卖审批中'
            break
          case 4:
            rs = '报废审批中'
            break
          case 5:
            rs = '调动审批中'
            break
          case 98:
            rs = '已变卖'
            break
          case 99:
            rs = '已报废'
            break
          default:
            rs = '未知状态'
            break
        }
        return rs
      }
      return cellValue
    },
    //列表导出
    ExportAction () {
      this.exportLoading = true
      exportFileId(this.pageQuery).then(rep => {
        if (rep.data.Code == 0) {
          this.exportLoading = false
          if (this.pageQuery.IsOutSideVehicle == 0) {
            window.open(`/common/CommonTemplateDown/DownExportFile?ft=0&&id=${rep.data.Data}`)
          }
          else {
            window.open(`/common/CommonTemplateDown/DownExportFile?ft=115&&id=${rep.data.Data}`)
          }
        }
      }).catch(() => {
        this.exportLoading = false
      });
    },
    setRowClass ({ row }) {
      if (row && row.RemindCount == 0 && row.Status !== 98 && row.Status !== 99) {
        return `remind-danger`
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.newTab {
    display: flex;
    background: #f2f3f5;

    li {
        padding: 13px 23px;
        border-radius: 0px;
        cursor: pointer;
        border-bottom: 1px solid #e4e7ed;

        &:first-child {
            border-left: 0px
        }
    }

    .tabActive {
        background: #fff;
        color: #2D4A98;
        border-bottom: 0px;
        border-right: 1px solid #e4e7ed;
        border-left: 1px solid #e4e7ed;
        //  border-top: 4px solid #2D4A98;
        position: relative;

        &::after {
            content: "";
            height: 4px;
            width: 100.8%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: #2D4A98;
        }
    }

    .newTabIcon {
        flex: 1;
        cursor: inherit;
        border-bottom: 1px solid #e4e7ed;
    }
}

.tabs-byleft::after {
    content: none !important;
}
</style>
<style>
.btns {
    text-align: right;
    width: 100%;
}

.my-dropdown-item {
    position: relative;
}

.remind-dog {
    background: rgba(251, 32, 43, 0.4);
    width: 10px;
    height: 10px;
    border-radius: 10px;
    position: absolute;
    top: 3px;
    right: -20px;
}

.btns {
    text-align: right;
    width: 100%;
}
</style>
  